<template>
	<p class="!m-0 flex items-center gap-1 !p-0">
		<span class="text-[13px]/[16px] font-medium">
			{{ price }}
		</span>
		<span v-if="original" class="text-[11px]/[16px] font-normal text-neutral-600 line-through">
			{{ original }}
		</span>
		<span v-if="savings" class="text-[11px]/[16px] font-normal text-orange-800">
			{{ savings }}
		</span>
	</p>
	<p
		v-if="isWholesale && retail && product.parentVariantGroup === 'Clothing'"
		class="text-[10px]/[14px] text-nowrap !m-0 !p-0"
	>
		No commission
	</p>
	<p v-else-if="isWholesale && retail" class="text-[10px]/[14px] text-nowrap !m-0 !p-0">Retail: {{ retail }}</p>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useProductStore } from '@stores'

const props = defineProps({
	product: {
		type: Object,
		required: true,
	},
})

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)

const price = computed(() => selectedVariant.value?.price)
const original = computed(() => selectedVariant.value?.original)
const savings = computed(() => selectedVariant.value?.savings)
const isWholesale = computed(() => props.product.isWholesale)
const retail = computed(() => selectedVariant.value?.retailPrice)
</script>
